import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { dayEndBreadcrumbsHistory } from './functions';

const DayEndBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="report-breadcrumbs"
      history={dayEndBreadcrumbsHistory(t, location)}
    />
  );
};

export default DayEndBreadcrumbs;
